import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  EnrichBatchPayload,
  EnrichBatchResult
} from "../../recommendation.types";
import { requestEnrichBatch } from "./enrichBatch.request";

const useEnrichBatch = (
  options?: MutationOptions<
    EnrichBatchResult,
    ApiServiceError<ApiError>,
    EnrichBatchPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestEnrichBatch,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "enrichment"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useEnrichBatch;
